import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            redirects: [],
            pages: [],
            activeTab: 'treeList',
        }
    },
    getters: {
        activeTab: (state) => state.activeTab,
        pages: (state) => state.pages,
    },
    mutations: {
        setRedirects(state, value) {
            state.redirects = value;
        },
        addRedirect(state, value) {
            state.redirects.data.unshift(value);
        },
        removeRedirect(state, item) {
            for (let i = 0; i < state.redirects.data.length; i++) {
                if (state.redirects.data[i].id === item.id) {
                    window.Vue.delete(state.redirects.data, i, item);
                }
            }
        },
        setActiveTab(state, value) {
            state.activeTab = value;
        },
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/familytree/redirect', payload)
                  .then((response) => {
                      commit('setRedirects', response.data);
                      resolve(response);
                  })
                  .catch((error) => {
                      reject(error);
                      console.log(error);
                  });
            });
        },
        create({state, commit, getters}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.post('/familytree/redirect', payload)
                  .then((response) => {
                      commit('removeRedirect', response.data);
                      commit('addRedirect', response.data);
                      resolve(response);
                  })
                  .catch((error) => {
                      reject(error);
                      console.log(error);
                  })
            });
        },
        update({state, commit, getters, dispatch}, payload) {
            return dispatch('create', payload);
        },
        deleteItem({state, commit, getters}, slug) {
            return new Promise((resolve, reject) => {
                ApiService.delete('/familytree/redirect/' + slug)
                  .then((response) => {
                      commit('removeRedirect', response.data);
                      resolve(response);
                  })
                  .catch((error) => {
                      reject(error);
                      console.log(error);
                  });
            });
        },
        restoreItem({state, commit, getters}, id) {

        },
    }
};
